import Vue from 'vue'
import store from '../../store'

const Auth = {

    endpoint: 'Users',

    login: async function (credentials) {
        return await Vue.prototype.$api._post(this.endpoint, credentials);
    }
}

export default Auth


// WEBPACK FOOTER //
// ./src/api/auth/auth.js